import { DatePickTypeProps } from './TypeProps';
import { AvailableString, AvailableType } from '@app/entities/Delivery';
import classNames from 'classnames';

import styles from './DatePick.module.scss';

export const DatePick = ({ available, record, className }: DatePickTypeProps): JSX.Element => {
  return (
    <div className={classNames(styles.Container, className)}>
      {available && (
        <div
          className={classNames(
            styles.Pick,
            available < AvailableType.PickUpTomorrow && styles.pickGreen,
            available !== AvailableType.NoInfo && available >= AvailableType.PickUpTomorrow && styles.pickOrange,
            (!available || available === AvailableType.NoInfo) && styles.pickRed,
          )}
        >
          {AvailableString[available]}
        </div>
      )}
      {record && available < AvailableType.PickUpTomorrow && <div className={styles.Record}>Шиномонтаж сегодня/завтра</div>}
    </div>
  );
};
